// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.25 2 H12.75 C13.44 2 14 2.56 14 3.25 V5.25 C14 5.94 13.44 6.5 12.75 6.5 H3.25 C2.56 6.5 2 5.94 2 5.25 V3.25 C2 2.56 2.56 2 3.25 2 Z',
  'M3.25 9.5 H7 C7.69 9.5 8.25 10.06 8.25 10.75 V12.75 C8.25 13.44 7.69 14 7 14 H3.25 C2.56 14 2 13.44 2 12.75 V10.75 C2 10.06 2.56 9.5 3.25 9.5 Z',
  'M11.75 9.5 H13 C13.55 9.5 14 9.95 14 10.5 V13 C14 13.55 13.55 14 13 14 H11.75 C11.2 14 10.75 13.55 10.75 13 V10.5 C10.75 9.95 11.2 9.5 11.75 9.5 Z',
];
